// ====================================================================================
// --- Arquivo: src/components/ui/LoadingSpinner.js ---
// ====================================================================================
import React from 'react';

// Indicador de carregamento discreto, na cor da marca e compatível com o modo escuro
export default function LoadingSpinner({ fullPage = false }) {
    const wrapperClass = fullPage
        ? "flex flex-col items-center justify-center gap-4 h-screen w-screen fixed top-0 left-0 bg-slate-50 dark:bg-slate-950 z-50"
        : "flex items-center justify-center p-10";
    const size = fullPage ? 44 : 36;
    return (
        <div className={wrapperClass} role="status" aria-live="polite">
            <span
                className="inline-block rounded-full animate-spin border-[3px] border-slate-200 dark:border-white/10 border-t-brand-core"
                style={{ width: size, height: size }}
            />
            {fullPage && (
                <span className="text-sm font-medium text-slate-500 dark:text-slate-400">Carregando...</span>
            )}
            <span className="sr-only">Carregando</span>
        </div>
    );
};
